export const REQUEST_COMPANY_START = 'REQUEST_COMPANY_START';
export const REQUEST_COMPANY_SUCCESS = 'REQUEST_COMPANY_SUCCESS';
export const REQUEST_COMPANY_ERROR = 'REQUEST_COMPANY_ERROR';
export const REQUEST_CUSTOMERS_COUNT_SUCCESS =
  'REQUEST_CUSTOMERS_COUNT_SUCCESS';
export const REQUEST_CUSTOMERS_COUNT_ERROR = 'REQUEST_CUSTOMERS_COUNT_ERROR';
